function createColumnData(name, param, order, sortable) {
  return { name, param, order, sortable };
}

export default createColumnData;
